import { render, staticRenderFns } from "./addVisit.vue?vue&type=template&id=545f0880&scoped=true"
import script from "./addVisit.vue?vue&type=script&lang=js"
export * from "./addVisit.vue?vue&type=script&lang=js"
import style0 from "./addVisit.vue?vue&type=style&index=0&id=545f0880&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f0880",
  null
  
)

export default component.exports